export default __webpack_public_path__ + "static/media/Arrow 2 Left.9c76c80a.svg";